import React from "react";
import styled from "styled-components";
import { Picture } from "~/components/PictureGallery/Picture";
import PictureGallery from "~/components/PictureGallery/PictureGallery";
import mediaQueries from "~/guidelines/Theme/mediaQueries";

const Wrapper = styled.div`
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueries.md()} {
    padding-bottom: 0;
  }
`;

const Background = styled.div`
  display: none;

  ${mediaQueries.md()} {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    ::before,
    ::after {
      content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 50%;
    }
    ::before {
      top: 0;
      background-color: ${({ theme }) => theme.color.background.lightSecond};
    }
    ::after {
      bottom: 0;
      background-color: ${({ theme }) => theme.color.background.darkFirst};
    }
  }
`;

const Card = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${mediaQueries.md()} {
    position: relative;
    z-index: 1;
    padding: ${({ theme }) => theme.spacing(6)};
    width: 90%;
    max-width: 1240px;
    background-color: ${({ theme }) => theme.color.background.lightThird};
    box-shadow: ${({ theme }) => theme.shadow.navigation};
    border-radius: ${({ theme }) => theme.borderRadius.default};
  }
`;

export type PictureGalleryProps = {
  gallery: Array<Picture>;
};

const RoomDetailsPictureGallery = ({ gallery }: PictureGalleryProps) => {
  return (
    <Wrapper>
      <Background />
      <Card>
        <PictureGallery gallery={gallery} />
      </Card>
    </Wrapper>
  );
};

export default RoomDetailsPictureGallery;
